import React, { createRef, useContext, useState } from "react";
import "./MyFav.scss";
import { inject, observer } from "mobx-react";
import RootStore from "../../store/RootStore";
import ComponentLink from "../ComponentLink";
import { ThemeContext } from "../../store/ThemeProvider";
import { MyGalleryWithTitle } from "../MyPhotos/Main";
import ListWrapper from "../Common/ListWrapper";
import { ICommonMyList } from "./AllForMe";
import { IListResult } from "../../global";
import GorgeousHeader from "../Followee/GorgeousHeader";
import SimpleBigPic from "../BigPic/SimpleBigPic";
import useSimpleBigPic from "../BigPic/useSimpleBigPic";
import intl from "react-intl-universal";
import { alpha } from '../../utils/color';

interface IMyFav extends ICommonMyList {}

const MyFav = (props: IMyFav) => {
  const { componentColor, h1Color, mainColor, h2Color, backgroundColor } =
    useContext(ThemeContext);
  const { formattedList } = props;
  const { keys = [], result = {} } = formattedList || {};

  const {
    list: theList,
    columnsClick,
    setBigIndex,
    bigIndex,
    loadBigPic,
    loadFinish,
  } = useSimpleBigPic(result, function (a: string, b: string) {
    return +a < +b ? 1 : -1;
  });

  return (
    <div className="my-fav">
      <ListWrapper
        onRefresh={props.refresh}
        onLoadMore={props.loadMore}
        scrollerChildrenSelector={".my-fav"}
        eventName={"fav"}
      >
        <>
          {keys.map((key: string) => {
            return (
              <MyGalleryWithTitle
                key={key}
                {...result[key]}
                column="4"
                onClickTitle={() => ComponentLink.to(result[key].gallery)}
                columnsClick={columnsClick}
                h1Color={h1Color}
                mainColor={mainColor}
                h2Color={h2Color}
              />
            );
          })}
        </>
      </ListWrapper>
      <SimpleBigPic
        pageType="MyFav"
        index={bigIndex}
        list={theList}
        setIndex={setBigIndex}
        loadBigPic={loadBigPic}
        loadFinish={loadFinish}
      />
    </div>
  );
};

export default observer(MyFav);
